@if (examListConfig) {
<div class="exam-list">
  <qa-grid-data [config]="examListConfig">
    <qa-no-entity-info noContent [listInfo]="listInfo"></qa-no-entity-info>
  </qa-grid-data>
</div>
}
